import React from 'react';
import { ico_bell } from '../../icon';
import Stylesheet from './Notification.module.css';
import {Link} from 'react-router-dom';
import util from '@enigma/core/utilities';

const Notification = (props) => {
    const metadata = props.metadata;
    const user = props.user;
    const dueIn = _ => {
        if (metadata.due > new Date().getTime()) {
            // going to be due
            const differece = new util.cdate();
            differece.getDayDifference(metadata.due);
            return <span>due in {differece.getDayDifference(metadata.due)} days</span>
        } else {
            // already due
            return <span>already due</span>
        }
    }
    const header = _ => {
        if (user.admin)
            return <h5>{metadata.branch}&emsp;&middot;&emsp;
            {metadata.table}&emsp;&middot;&emsp;{metadata.column}</h5>;
        return <h5>{metadata.table}&emsp;&middot;&emsp;{metadata.column}</h5>;
    }
    if (metadata.type === "notify")
        return (
            <div className={Stylesheet.Container}>
                <Link to={`/${metadata.url}`}>
                    <h6>{ico_bell}&emsp;notify&emsp;&middot;&emsp;{dueIn()}</h6>
                    {header()}
                    <h5>a particular record in the {metadata.table} table has been identified
                    as due, please update this record and cancle this notification in the future.</h5>
                </Link>
            </div>
        )
}

export default Notification;